module.exports = __webpack_public_path__ + "html/wave-header_427a74bf561f1ede885f60d4218c997a.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/wave-header.html
// module id = eXN9
// module chunks = 151